import React, { FC } from 'react';

import { Icons, IconsTypes } from '@/components/shared/Icons';
import { Image } from '@/components/shared/Image';
import { Link } from '@/components/shared/Link';
import { useLocale } from '@/hooks/useLocale';
import { IPlantDetails, OptimizedImageSizes } from '@/types';

interface IPlantListItem {
  plant: IPlantDetails;
}

const NAME_LIMIT = 30;

export const PlantListItem: FC<IPlantListItem> = ({ plant }) => {
  const { isEnLocale } = useLocale();

  const name = isEnLocale ? plant.name_en : plant.name;
  const isTextMoreThanLimit = name.length > NAME_LIMIT;
  const textWithDots = isTextMoreThanLimit ? `${name.substring(0, NAME_LIMIT)}...` : name;

  const mainImage = plant.images?.find((img) => img.is_main);

  return (
    <Link className="w-full" href={`/plant/${plant.slug}`}>
      <div className="relative flex min-h-[210px] items-end overflow-hidden rounded-lg">
        <div className="absolute h-full w-full">
          <Image
            className="h-full w-full object-cover"
            src={mainImage?.img as string}
            optimized={mainImage?.image as OptimizedImageSizes}
            alt={name}
          />
        </div>
        <div className="relative flex w-full items-center justify-between px-3 py-2">
          <div className="relative z-10">
            <h4 className="text-md font-bold text-white">{textWithDots}</h4>
          </div>
          <div className="z-10 ml-2 text-white">
            {Icons({
              name: IconsTypes.ARROW_RIGHT,
            })}
          </div>
          <div className="absolute left-0 top-0 h-full w-full bg-black-400 opacity-70" />
        </div>
      </div>
    </Link>
  );
};
